import { render } from "./App.vue?vue&type=template&id=586c19bf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=586c19bf&lang=css"

import exportComponent from "/home2/werkfijnprodprev/releases/66/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__